import Immutable from 'immutable';

export interface RawUserQuery {
  email: string;
  name: string;
  company: string;
  role: string;
  perm: string;
  sortDirection: 'ascending' | 'descending';
  sortField: string;
}

export interface UserQueryData {
  email: string;
  name: string;
  company: string;
  role: string;
  perm: string;
  sortDirection: 'ascending' | 'descending';
  sortField: string;
}

const defaultValues: UserQueryData = {
  email: '',
  name: '',
  company: '',
  role: '',
  perm: '',
  sortDirection: 'ascending',
  sortField: 'perm',
};

export const UserQueryFactory = Immutable.Record(defaultValues, 'UserQuery');

export class UserQuery extends UserQueryFactory {
  static deserialize(rawSubmittalQuery: RawUserQuery): UserQuery {
    return new UserQuery({
      sortDirection: rawSubmittalQuery.sortDirection,
      sortField: rawSubmittalQuery.sortField,
    });
  }

  serialize(): RawUserQuery {
    return this.toJS();
  }
}
